import { render, staticRenderFns } from "./PlanEdit.vue?vue&type=template&id=bf11ff62"
import script from "./PlanEdit.vue?vue&type=script&lang=js"
export * from "./PlanEdit.vue?vue&type=script&lang=js"
import style0 from "./PlanEdit.vue?vue&type=style&index=0&id=bf11ff62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports